import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';

export const deleteDefaultPromocode = () => {
	saveToSessionStorage(ssKeys.PROMOCODE, undefined);
};

export const saveDefaultPromocode = (promocode: string) => {
	saveToSessionStorage(ssKeys.PROMOCODE, promocode);
};

export const getDefaultPromocode = () => {
	return loadFromSessionStorage<string | undefined>(
		ssKeys.PROMOCODE,
		undefined
	);
};
